/**
 * @file 客户端关于登录的接口
 */

import Cookie from 'js-cookie';
import { http } from './http';

// cookie的key值
export const COOKIE_KEY = {
  qbid: 'qbtool_qbid',
  openid: 'qbtool_openid',
  token: 'qbtool_token',
  logintype: 'qbtool_logintype',
  loginname: 'qbtool_loginname',
  loginlogo: 'qbtool_loginlogo',
  refresh_token: 'qbtool_refresh_token',
  appid: 'qbtool_appid',
};

// 根据从客户端取出来的mode，获取登录类型
const getLoginType = (mode: number): 'wx' | 'qq' | 'qqsdk' => {
  if (mode === 3) return 'wx';
  if (mode === 5) return 'qq';
  return 'qqsdk';
};

// 将从客户端获取到的登录信息写到cookie内，以便以请求后台接口的时候可以带上。为了安全，只写session cookie
const writeLoginInfo2Cookie = async (loginInfo: Record<string, any> = {}) => {
  const option = { sameSite: 'strict' as any, domain: '.browser.qq.com', secure: true };
  const loginType = getLoginType(loginInfo.mode);
  Cookie.set(COOKIE_KEY.loginlogo, loginInfo.faceUrl, option);
  Cookie.set(COOKIE_KEY.loginname, loginInfo.nickName, option);
  Cookie.set(COOKIE_KEY.logintype, loginType, option);
  Cookie.set(COOKIE_KEY.openid, loginInfo.openid, option);
  Cookie.set(COOKIE_KEY.token, loginInfo.ctk, option);
  Cookie.set(COOKIE_KEY.appid, loginInfo.appid, option);

  const loginlogo = loginInfo.faceUrl;
  const loginname = loginInfo.nickName;
  let logintype = loginType;
  const { openid } = loginInfo;
  let token = loginInfo.ctk;
  const { appid } = loginInfo;
  // 如果登录是走的老的 ctk token，需要换成accesstoken token
  if (loginType === 'qqsdk') {
    const res = await http({
      url: 'https://login.browser.qq.com/qq/check_ctk',
      method: 'get',
      param: {
        ctk: loginInfo.ctk,
        openid: loginInfo.openid,
        clientid: loginInfo.appid,
      },
    });
    console.log('🚀 ~ file: nativeApi.ts:48 ~ writeLoginInfo2Cookie ~ res:', res);
    if (res?.ret === 0 && res?.data) {
      Cookie.set(COOKIE_KEY.logintype, 'qq', option);
      Cookie.set(COOKIE_KEY.token, res.data, option);
      logintype = 'qq';
      token = res.data;
    }
  }
  return {
    loginlogo,
    loginname,
    logintype,
    openid,
    token,
    appid,
  };
};

// 拉起navite的登录弹框
const showLoginPanel = (): Promise<any> => new Promise((resolve) => {
  console.log('[native showLoginPanel]');
  // @ts-ignore
  window.chrome?.account?.onLoginStatusChanged?.addListener((res: string) => {
    console.log('[native onLoginStatusChanged]', res);
    if (res === 'login-on') {
      getLoginInfo().then((loginInfo) => {
        resolve(loginInfo);
      });
    } else {
      resolve({
        ret: 0,
        data: {
          isLogin: false,
        },
      });
    }
  });
  // @ts-ignore
  window.chrome?.account?.promptLogin?.(() => { });
});

export const isGetLoginInfoExist = () => {
  return !!window?.chrome?.account;
};

// 获取登录信息。使用客户端接口获取登录信息后，需要将登录信息写入cookie中，以便请求后台接口时能带给后台。
export const getLoginInfo = (): Promise<any> => new Promise((resolve) => {
  // @ts-ignore
  window?.chrome?.account?.getLoginInfo((res) => {
    console.log('[navite getLoginInfo]', res);
    if (res.isLogin) {
      writeLoginInfo2Cookie(res).then((loginInfo: any) => {
        resolve({
          isLogin: res?.isLogin ?? false,
          logo: res?.faceUrl,
          nick_name: res?.nickName,
          qbid: res?.qbid,
          loginlogo: res.faceUrl,
          loginname: res.nickName,
          openid: res.openid,
          appid: res.appid,
          logintype: loginInfo.logintype,
          token: loginInfo.token,
          accessToken: loginInfo.token,
        });
      });
    } else {
      resolve({
        isLogin: res?.isLogin ?? false,
        logo: res?.faceUrl,
        nick_name: res?.nickName,
        qbid: res?.qbid,
        loginlogo: res.faceUrl,
        loginname: res.nickName,
        openid: res.openid,
        appid: res.appid,
      });
    }
  });
});


const logout = (): Promise<boolean> => new Promise((resolve) => {
  // @ts-ignore
  window?.chrome?.account?.logout((res) => {
    resolve(res);
  });
});

export const native = {
  showLoginPanel,
  getLoginInfo,
  logout,
};
